import { useState, useEffect, useCallback } from 'react';
import { adminAPI } from '@/services/api';
import { Customer, Plan } from '@/types';

export const useCustomers = (includeDeleted: boolean) => {
  const [customers, setCustomers] = useState<Customer[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  const fetchCustomers = useCallback(async () => {
    try {
      setLoading(true);
      setError('');
      const response = await adminAPI.getCustomers(0, 1000, includeDeleted);
      setCustomers(response.customers);
    } catch (err: any) {
      setError(err.response?.data?.detail || '고객사 목록을 불러오는데 실패했습니다.');
    } finally {
      setLoading(false);
    }
  }, [includeDeleted]);

  useEffect(() => {
    fetchCustomers();
  }, [fetchCustomers]);

  return { customers, loading, error, fetchCustomers, setCustomers, setError };
};

export const usePlans = () => {
  const [plans, setPlans] = useState<Plan[]>([]);

  useEffect(() => {
    const fetchPlans = async () => {
      try {
        const response = await adminAPI.getPlans();
        setPlans(response);
      } catch (error) {
        console.error('Failed to fetch plans:', error);
      }
    };
    fetchPlans();
  }, []);

  return plans;
};

export const useMainDomain = () => {
  const [mainDomain, setMainDomain] = useState('localhost');

  useEffect(() => {
    const fetchMainDomain = async () => {
      try {
        const response = await adminAPI.getMainDomain();
        setMainDomain(response.setting_value || 'localhost');
      } catch (error) {
        console.error('Failed to fetch main domain:', error);
        setMainDomain('localhost');
      }
    };
    fetchMainDomain();
  }, []);

  return mainDomain;
};

